module.exports = __webpack_public_path__ + "static/media/Ripe_Stone_Fruit.ff6b9d56.webp";